/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: SwitchActiveRecipePanel.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/13 @ 1411
 * ---
 * Description:
 */

import {HasEditor} from '../../../common/props';
import {MyLabelCompanyMeta, MyLabelRevision} from '../../../entities';
import {Icon} from '@blueprintjs/core';
import {ActiveCompanySelect} from "../select/data-origin/ActiveCompanySelect";
import {ActiveRevisionSelect} from "../select/data-origin/ActiveRevisionSelect";

interface Props extends HasEditor {
    onCompanySelect: (company: MyLabelCompanyMeta) => void;
    onRecipeSelect: (recipe: MyLabelRevision) => void;
    className?: string;
}

export const SwitchActiveRevisionPanel = (props: Props) => {
    return (
        <div className={props.className}>
      <div className="text-xl mb-2">Organizzazione attiva</div>
      <div className="bp4-text-muted mb-2">Seleziona l'organizzazione MyLabel
        attiva
        per il progetto aperto
      </div>
      <ActiveCompanySelect onCompanySelect={ props.onCompanySelect }
                           editor={ props.editor }/>
      <div className="text-xl mb-2 mt-4">Revisione MyLabel attiva</div>
      <div className="bp4-text-muted mb-2">Seleziona la revisione MyLabel attiva
        per
        il progetto aperto o <a target="_blank"
                                href="http://beta.mylabel.it/it/schede/labelrevisions/?dsid=&has_version=1">
          vedi elenco revisioni disponibili su MyLabel <Icon
          icon="backlink" className="mr-1"/>
        </a>
      </div>
      <ActiveRevisionSelect
        onRevisionSelect={ props.onRecipeSelect }
        editor={ props.editor }/>
    </div>
  );
};
